import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import useScrollToSection from "../../hooks/useScrollToSection.js";
import { trackCTA } from "../../lib/analytics";
import useLocalizedHref from "../../hooks/useLocalizedHref.js";

/**
 * Page hero. Mirrors the home Hero's brand voice (display face at `heading-9vw`)
 * but carries the supporting copy and CTAs a landing page needs.
 *
 * Deliberately no `data-w-id` / inline `opacity: 0`: those are Webflow
 * animation hooks, and an element the animation engine never reveals stays
 * invisible. The hero carries the page's H1, so it must render unconditionally.
 */
const PhotoSharingHero = ({ secondarySectionId }) => {
  const { t } = useTranslation();
  const localize = useLocalizedHref();
  const analyticsContext = useAnalyticsContext();

  // Renders as a plain `#id` anchor; the handler only corrects where it lands.
  const scrollToSecondary = useScrollToSection(secondarySectionId);

  return (
    <header className="section wps-hero">
      <div className="container">
        <p className="wps-eyebrow">{t("weddingPhotoSharing.hero.eyebrow")}</p>
        <h1 className="heading-9vw wps-hero-heading">
          {t("weddingPhotoSharing.hero.heading")}
        </h1>
        <p className="body-20 wps-hero-body">
          {t("weddingPhotoSharing.hero.body")}
        </p>
        <div className="wps-hero-actions">
          <Button
            href={localize("/")}
            text={t("weddingPhotoSharing.hero.ctaPrimary")}
            className="button-lg"
            onClick={() =>
              trackCTA("wedding_photo_sharing_hero", {
                ...analyticsContext,
                ctaName: "discover_agapae",
              })
            }
          />
          <a
            className="wps-text-link"
            href={`#${secondarySectionId}`}
            onClick={scrollToSecondary}
          >
            {t("weddingPhotoSharing.hero.ctaSecondary")}
          </a>
        </div>
      </div>
    </header>
  );
};

export default PhotoSharingHero;
